import React, { memo } from "react";
import { motion } from "framer-motion";
import { awardsData } from "../utility/awardsData";
import trophyimage from "../../assets/trophy.png";
import hysea from "../../assets/homePage/hysea.png";

// Award Card Component
const AwardCard = memo(({ imgSrc, title, description }) => (
  <motion.div
    className="p-6 text-center rounded-xl bg-white text-black border-2 border-orange-500"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      opacity: { duration: 0.5 },
      y: { type: "spring", stiffness: 100, damping: 20 },
    }}
    viewport={{ once: true, amount: 0.5 }}
  >
    <div>
      <img
        src={imgSrc}
        alt={title}
        className="w-full h-auto object-cover rounded-md mb-4"
        loading="lazy"
      />
      <h4 className="text-lg font-semibold mb-2">{title}</h4>
      <p>{description}</p>
    </div>
  </motion.div>
));

// Animation Variants
const rollingCylinderAnimation = {
  hidden: {
    rotateX: 90,
    opacity: 0,
  },
  visible: {
    rotateX: 0,
    opacity: 1,
    transition: {
      duration: 1.5,
      ease: "easeInOut",
    },
  },
};

const containerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
    },
  },
};

const Awards = () => {
  return (
    <div className="">
      {/* Hysea Award Section */}
      <section className="w-full px-4 py-10 bg-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-8">
          <div className="w-full md:w-1/2">
            <img
              src={hysea}
              alt="Proud moment"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          <div className="w-full md:w-1/2">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Proud Moment for AiSPRY
            </h3>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              We proudly stood our ground through intense competition—250
              startups in Round 1, 100 in Round 2, and 40 in the Finals—and
              emerged <span className="font-semibold">VICTORIOUS</span> at the{" "}
              <strong>32nd HYSEA National Summit & Awards 2025</strong> — AI &
              Beyond: Defining the Future! <br />
              <br />
              At the core of this achievement is <strong>Garbha</strong>,
              AiSPRY's groundbreaking innovation that's transforming IVF through
              AI-powered embryo quality assessment—boosting accuracy, improving
              viability predictions, and enhancing implantation success rates.{" "}
              <br />
              <br />
              This moment was made even more special as our dedicated AiSPRY
              team received the award from Telangana’s IT Minister,
              <strong> Sridhar Babu</strong> — This recognition stands as a
              testament to our unwavering commitment to advancing the frontiers
              of AI in healthcare. <br />
              <br />
              The future of AI-driven healthcare is not just on the horizon; it
              is here, and we are proud to be at the forefront of this
              transformative journey!
            </p>
          </div>
        </div>
      </section>

      {/* Awards & Accolades Section */}
      <div className="relative mt-8">
        {/* Background Image */}
        <img
          src={trophyimage}
          alt="Trophy Background"
          className="absolute inset-0 w-full h-full object-cover  z-0"
        />

        {/* Optional Overlay */}
        <div className="absolute inset-0  z-0" />

        {/* Foreground Content */}
        <div className="relative z-10 p-8 md:w-[75%] mx-auto">
          <motion.h3
            className="text-5xl font-large text-white text-center mb-16 "
            style={{
              transformOrigin: "center bottom",
              perspective: 1000,
            }}
            variants={rollingCylinderAnimation}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            Awards & Accolades
          </motion.h3>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            {awardsData.map((award, index) => (
              <AwardCard
                key={index}
                imgSrc={award.imgSrc}
                title={award.title}
                description={award.description}
              />
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Awards;
